import { billetStatus } from '@transfeeradev/api-enums';

export default {
  [billetStatus.PAID]: [billetStatus.PAID, billetStatus.FINISHED],
  [billetStatus.FAILED]: billetStatus.FAILED,
  [billetStatus.SCHEDULED]: billetStatus.SCHEDULED,
  [billetStatus.RETURNED]: billetStatus.RETURNED
};
